module.exports = __webpack_public_path__ + "static/media/tarot-card-8.6dfb2fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-8.jpg
// module id = 1554
// module chunks = 0